<template>
    <div style="box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);">
        <div style="position:fixed; left: 0; top: 0; width:100%; height:100%; background-color: rgba(0,0,0,0.3);" @click="close"></div>
        <div style="position: absolute; display: flex; flex-direction: column; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 320px; background-color: var(--color-main); border-radius: 12px;">
            <div style="border-top-left-radius: 12px; border-top-right-radius: 12px; padding: 16px 12px; text-align: center; color: #fff; font-size: 20px; font-weight: 500;">{{ $GlobalStore.confirmTitle() }}</div>
            <div style="display: flex; background-color: #fff; border-radius: 12px; padding: 12px; padding-top: 24px; flex: 1; box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2); gap: 12px; justify-content: center;">
                <div v-if="$GlobalStore.confirmOkName()" class="common_btn" @click="ok">{{ $GlobalStore.confirmOkName() }}</div>
                <div v-if="$GlobalStore.confirmCancelName()" class="common_btn" @click="cancel">{{ $GlobalStore.confirmCancelName() }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CommonConfirm",
    methods: {
        ok() {
            this.$GlobalStore.okConfirm();
            this.$GlobalStore.hideConfirm();
        },
        cancel() {
            this.$GlobalStore.hideConfirm();
            this.$GlobalStore.cancelConfirm();
        },
        close(){
            this.$GlobalStore.hideConfirm();
        }
    },
}
</script>

<style scoped>
.common_btn {
    padding: 8px;
    background-color: var(--color-main);
    flex: 1;
    text-align: center;
    border-radius: 12px;
    padding: 14px 8px;
    color: #fff;
    font-weight: 500;
    font-size:20px;
}
</style>